import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ConciergeChatContent from "./ConciergeChatContent";
import ChatForm from "./ChatForm";
import ChatSuccess from "./ChatSuccess";
import ChatError from "./ChatError";

function RenderChatContent({
  pageString,
  setPageContent,
  setShowPopup,
  isContactSupport,
  isMyCssContactSupport,
}) {
  switch (pageString) {
    case "landing":
      return (
        <ConciergeChatContent
          setPageContent={setPageContent}
          closeChat={() => setShowPopup(true)}
        />
      );
    case "form":
      return (
        <ChatForm
          setPageContent={setPageContent}
          isContactSupport={isContactSupport}
          isMyCssContactSupport={isMyCssContactSupport}
        />
      );
    case "success":
      return (
        <ChatSuccess
          isContactSupport={isContactSupport}
          isMyCssContactSupport={isMyCssContactSupport}
        />
      );
    case "error":
      return <ChatError setShowPopup={setShowPopup} />;
    default:
      return null;
  }
}

RenderChatContent.propTypes = {
  pageString: PropTypes.string.isRequired,
  setPageContent: PropTypes.func.isRequired,
  setShowPopup: PropTypes.func.isRequired,
  isContactSupport: PropTypes.bool.isRequired,
  isMyCssContactSupport: PropTypes.bool.isRequired,
};

function LandingChat({ setShowPopup, isContactSupport, isMyCssContactSupport }) {
  const defaultPage = isContactSupport || isMyCssContactSupport ? "form" : "landing";
  const [page, setPageContent] = useState(defaultPage);

  const setPageHandler = (newValue) => {
    setTimeout(() => {
      setPageContent(newValue);
    }, 10);
  };

  return (
    <div className="conciergeChatWrapper">
      <RenderChatContent
        pageString={page}
        setPageContent={setPageHandler}
        setShowPopup={setShowPopup}
        isContactSupport={isContactSupport}
        isMyCssContactSupport={isMyCssContactSupport}
      />
    </div>
  );
}

LandingChat.propTypes = {
  setShowPopup: PropTypes.func.isRequired,
  isContactSupport: PropTypes.bool.isRequired,
  isMyCssContactSupport: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isContactSupport: state.global.isSupportChat,
  isMyCssContactSupport: state.global.isMyCssSupportChat,
});

export default connect(mapStateToProps)(LandingChat);
